import { request } from '@/shared/api/request'

export const getMembers = (externalId, params) => {
	return request({ url: `colcontract/tradeUnion/person/page/${externalId}`, method: 'POST', params })
}
